(function() {
  'use strict';

  function getMenuButton() {
    return document.querySelector('.header-type-4 .mobile-btn');
  }

  function syncMenuState() {
    var button = getMenuButton();
    if (!button || !document.body) return;

    var open = document.body.classList.contains('mobile-menu-open');
    var menu = document.querySelector('.fmm-mobile');

    if (menu) {
      if (!open && menu.contains(document.activeElement)) {
        button.focus({ preventScroll: true });
      }
      menu.toggleAttribute('inert', !open);
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  function setMenuState(open) {
    if (!document.body) return;

    document.body.classList.toggle('mobile-menu-open', open);
    if (!open) {
      document.body.classList.remove('mobile-sidebar-open');
    }
    syncMenuState();
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest && event.target.closest('.header-type-4 .mobile-btn');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    setMenuState(!document.body.classList.contains('mobile-menu-open'));
  }, true);

  document.addEventListener('click', function(event) {
    var overlay = event.target.closest && event.target.closest('.mobile-menu-overlay');
    if (!overlay) return;
    setMenuState(false);
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      setMenuState(false);
    }
  });

  function initMenuState() {
    if (!getMenuButton() || !document.body) return;
    syncMenuState();
    new MutationObserver(syncMenuState).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuState);
  } else {
    initMenuState();
  }
})();

